import { FC, useEffect, useRef, useState } from 'react';

import { YbCoreModal } from '@yubi/yb-core-modal-v3';
import { ModalProps } from '@yubi/yb-core-modal-v3/dist/dts/YbCoreModal.types';

const CoreModal: FC<ModalProps> = ({
  showCloseIcon = true,
  open,
  onDismiss,
  onModalClose,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(open ?? false);
  const prevOpenRef = useRef<boolean | undefined>(undefined);

  useEffect(() => {
    if (open === true && prevOpenRef.current !== true) {
      setIsOpen(true);
    } else if (open === false) {
      setIsOpen(false);
    }
    prevOpenRef.current = open;
  }, [open]);

  const handleDismiss = () => {
    setIsOpen(false);
    onDismiss?.();
  };

  const handleModalClose = () => {
    setIsOpen(false);
    onModalClose?.();
  };

  return (
    <YbCoreModal
      {...props}
      open={isOpen}
      showCloseIcon={showCloseIcon}
      onDismiss={handleDismiss}
      onModalClose={handleModalClose}
    />
  );
};

export default CoreModal;
